export default __webpack_public_path__ + "static/media/clients-landing-5.9eb1a971.jpg";